import AddressForm from 'components/RichProfile/MyAccount/TaxClaim/AddressForm/AddressForm';
import { withAddressFormProps } from 'viewModel/richProfile/myAccount/taxClaim/withAddressFormProps';

export default withAddressFormProps(AddressForm);
